const middleware = {}

middleware['auth'] = require('../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['maintain'] = require('../middleware/maintain.js')
middleware['maintain'] = middleware['maintain'].default || middleware['maintain']

export default middleware
